import { Box } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import PaymentInWizard from "pages/vending/machine/create/PaymentInWizard";
import React from "react";

const AssignPaymentsDialog = ({ open, handleClose, machine }) => {
  return (
    <CustomDialog
      fullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Choose a payment to add "
    >
      <Box padding={2}>
        <PaymentInWizard machine={machine} fullGrid={true} />
      </Box>
    </CustomDialog>
  );
};

export default AssignPaymentsDialog;
